export const stats = [
  { value: '8', label: 'Volumi Completi' },
  { value: '500+', label: 'Pagine di Risorse' },
  { value: '80', label: 'Unità Didattiche' },
  { value: '100%', label: "Pronto per l'Aula" },
]

export const beforeItems = [
  'Passare le domeniche a pianificare ogni singola lezione.',
  'Cacciare schede su Pinterest o Google che non si adattano mai alla tua classe.',
  'Nessuna progressione chiara anno dopo anno: ti senti sempre al punto di partenza.',
  'Dover creare da zero test di verifica e cercare le soluzioni.',
  'Sentirti frustrato perché la burocrazia ti toglie il piacere di insegnare.',
]

export const afterItems = [
  'Un intero anno mappato e organizzato per ogni classe.',
  'Lezioni, esercizi e schede pronti per la stampa o la LIM.',
  'Un curriculum a spirale logico dai 6 ai 14 anni.',
  'Insegnamento semplice passo dopo passo, anche se non sei uno specialista.',
  'Verifiche integrate e chiavi di correzione incluse per risparmiare settimane di lavoro.',
]

export const recognizeItems = [
  'Non hai più tempo per pianificare lezioni che siano davvero coinvolgenti.',
  'Vedi gli studenti annoiarsi con le solite vecchie attività ripetitive.',
  'Gestire livelli diversi nella stessa classe ti sembra una missione impossibile.',
  'Insegni musica fuori dalla tua specializzazione e hai paura di sbagliare.',
  'Non trovi nulla che funzioni davvero sia per i piccoli che per i ragazzi delle medie.',
]

export type Volume = {
  number: number
  title: string
  text: string
  level: string
  accent: string
}

export const primaryVolumes: Volume[] = [
  {
    number: 1,
    title: 'Il Risveglio Sonoro',
    text: 'Esplorazione del suono, del silenzio e primi passi ritmici.',
    level: '1ª Primaria',
    accent: '#e2483d',
  },
  {
    number: 2,
    title: 'Ritmo e Movimento',
    text: 'La pulsazione e il corpo come primo strumento.',
    level: '2ª Primaria',
    accent: '#f0913f',
  },
  {
    number: 3,
    title: 'Il Linguaggio delle Note',
    text: 'Lettura e scrittura facilitata sul pentagramma.',
    level: '3ª Primaria',
    accent: '#2f8fd6',
  },
  {
    number: 4,
    title: 'Emozioni in Musica',
    text: 'Ascolto attivo e viaggio tra i grandi compositori.',
    level: '4ª Primaria',
    accent: '#3fa96b',
  },
  {
    number: 5,
    title: 'Piccoli Compositori',
    text: 'Storia della musica e creazione di brani originali.',
    level: '5ª Primaria',
    accent: '#12988a',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    number: 6,
    title: 'Percorsi per la Secondaria',
    text: 'Approfondimento dei generi, tecnica e analisi.',
    level: '1ª Media',
    accent: '#16388f',
  },
  {
    number: 7,
    title: 'Verifiche e Soluzioni',
    text: 'Il tuo archivio completo per valutare in un secondo.',
    level: '2ª Media',
    accent: '#7e5bc4',
  },
  {
    number: 8,
    title: 'Programmazione Annuale',
    text: 'Traguardi e obiettivi scritti mese per mese per la tua burocrazia.',
    level: '3ª Media',
    accent: '#0d7a6f',
  },
]

export const bonuses = [
  {
    title: 'Kit "Prima Lezione Perfetta"',
    text: "Aggancia l'attenzione degli studenti dai primi 60 secondi e stabilisci la tua autorità con gioia.",
    value: '€39',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/24f4d658-7c71-42b1-9885-e0ed27e22363.jpg',
  },
  {
    title: 'Banca di Cues "Il Docente che Ispira"',
    text: 'Le parole esatte da usare per spiegare ritmo e armonia in modo che tutti capiscano al primo colpo.',
    value: '€37',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/99a6a321-7c29-4f72-a4c1-8ab650ba1d72.jpg',
  },
  {
    title: 'Sistema "Progresso Visibile"',
    text: 'Modelli di autovalutazione e certificati. Quando i genitori vedono il progresso, il tuo valore raddoppia.',
    value: '€39',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/89a395b1-39df-46e0-969c-d6b6c2d8ff55.jpg',
  },
  {
    title: 'Guida "Classi di Gruppo Senza Caos"',
    text: 'Il metodo per gestire 25 strumenti senza perdere il controllo della classe.',
    value: '€35',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7dc8715a-eb98-4e26-b7ac-bdc341637673.jpg',
  },
  {
    title: 'Kit "Anti-Cancellazioni e Motivazione"',
    text: 'Strategie psicologiche per mantenere gli studenti motivati e ridurre l\u2019assenteismo.',
    value: '€35',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c4b20778-ce62-458b-988f-3aa3b6c371a8.jpg',
  },
]

export type MaterialSlide = {
  src: string
  title: string
  label: string
  text: string
}

export const materialSlides: MaterialSlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/oZ5rvhCKZin9AzjbajfN8P/Captura-de-pantalla-2026-09-11-a-las-8.16.06_p._m..webp',
    title: 'Attività 3 — La Storia Sonora',
    label: 'Attività creativa',
    text: 'Storie da inventare con la voce per far scoprire piano e forte giocando.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dXwqYt5dUEFC8CvwaUuYK6/Captura_de_pantalla_2026-09-11_a_las_8.04.30_p.webp',
    title: 'Attività 2 — Leggo e Suono!',
    label: 'Attività pratica',
    text: 'Ritmi pronti da leggere, battere e suonare, con la progressione già scritta.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dbYcN99SmkTbzm1a6ghyYg/Captura-de-pantalla-2026-09-11-a-las-8.17.43_p._m..webp',
    title: 'La Scala Completa di DO',
    label: 'Struttura melodica',
    text: 'Gli 8 gradini della scala spiegati con immagini che i bambini ricordano subito.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ijiHYSBzJ6CY168r4o7A4B/Captura-de-pantalla-2026-09-11-a-las-8.06.56_p._m..webp',
    title: 'Gli Archi — La Famiglia più Numerosa',
    label: 'Strumenti e ascolto',
    text: 'Schede sugli strumenti dell’orchestra, perfette per la LIM e per l’ascolto guidato.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ixPfbeC8fGRcJsXnFHQ78o/Captura-de-pantalla-2026-09-11-a-las-8.07.53_p._m..webp',
    title: 'Gli Intervalli Musicali',
    label: 'Scuola Media',
    text: 'Teoria avanzata riassunta in tabelle chiare, con esempi che i ragazzi conoscono.',
  },
]

export const offerRows = [
  { label: 'Musica Pronta (8 Volumi)', value: '€67' },
  { label: '5 Bonus Strategici', value: '€30' },
]

export const testimonials = [
  {
    quote:
      'È esattamente quello di cui avevo bisogno. La programmazione annuale da sola vale il prezzo. Ho finalmente recuperato le mie domeniche.',
    name: 'Sara M.',
    role: 'Insegnante Scuola Primaria',
  },
  {
    quote:
      'Le schede sono bellissime e i ragazzi delle medie non si annoiano. Un materiale di qualità rara in Italia.',
    name: 'Giacomo T.',
    role: 'Docente di Musica',
  },
]

export const faqs = [
  {
    q: 'In che formato sono i materiali?',
    a: 'Sono PDF ad alta risoluzione pronti da stampare o proiettare sulla LIM.',
  },
  {
    q: 'È adatto a chi non ha basi musicali forti?',
    a: 'Sì, è progettato per guidare il docente passo dopo passo.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente dopo il pagamento via email.',
  },
  {
    q: 'Posso usarlo su tablet?',
    a: 'Sì, i file sono compatibili con qualsiasi dispositivo digitale.',
  },
  {
    q: 'Devo pagare un abbonamento mensile?',
    a: 'No. È un pagamento unico e l’accesso ai materiali resta tuo per sempre.',
  },
  {
    q: 'E se non fa per me?',
    a: 'Hai 7 giorni di garanzia: ti rimborsiamo tutto e puoi tenere i 5 bonus.',
  },
]

export const heroGuarantees = [
  'Download digitale istantaneo',
  'PDF pronti per la stampa',
  'Pagamento unico',
]

export const footerLinks = ['Termini e Condizioni', 'Privacy Policy', 'Contatti']
